export const TIME_ENTRY_STATE = {
	SUCCESS: 'success',
	ERROR: 'error',
} as const;
